module.exports = __webpack_public_path__ + "media/images/flags/bg-b0e1a52fe17361ed7ded541b8046f701.svg";